import { useEffect, useState } from "react"

export function useUTM() {
  const [value, setValue] = useState<Record<string, string>>({}) // default empty object

  useEffect(() => {
    const vals = captureUtm()
    if (vals) setValue(vals)
  }, [])

  return value
}

export function captureUtm(): Record<string, string> {
  try {
    if (document.location.search.includes("utm_")) {
      const utmValues: Record<string, string> = {}
      const params = new URLSearchParams(document.location.search)
      params.forEach((v, k) => {
        if (k.startsWith("utm_")) utmValues[k] = v
      })
      localStorage.setItem("utm_values", JSON.stringify(utmValues))
      localStorage.setItem("utm_expires", String(Date.now() + 1000 * 60 * 60 * 24 * 7))
      return utmValues
    } else {
      const stored = JSON.parse(localStorage.getItem("utm_values") || "{}")
      const expired = Number(localStorage.getItem("utm_expires")) < Date.now()
      if (expired) return {}
      return stored
    }
  } catch {
    return {}
  }
}
